import { render, staticRenderFns } from "./indexManage.vue?vue&type=template&id=acfc3582&"
import script from "./indexManage.vue?vue&type=script&lang=js&"
export * from "./indexManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports